"use strict";
function UncaughtError(firebaseErrorCode) {
    this.firebaseErrorCode = firebaseErrorCode;
}
exports.UncaughtError = UncaughtError;
Object.setPrototypeOf(UncaughtError, Error);
UncaughtError.prototype = Object.create(Error.prototype);
UncaughtError.prototype.name = "UncaughtError";
UncaughtError.prototype.message = "";
UncaughtError.prototype.constructor = UncaughtError;
function AccountExistsError(existingProviderId) {
    this.existingProviderId = existingProviderId;
}
exports.AccountExistsError = AccountExistsError;
Object.setPrototypeOf(AccountExistsError, Error);
AccountExistsError.prototype = Object.create(Error.prototype);
AccountExistsError.prototype.name = "AccountExistsError";
AccountExistsError.prototype.message = "";
AccountExistsError.prototype.constructor = AccountExistsError;



/** WEBPACK FOOTER **
 ** ./src/api/types.ts
 **/